import Vue from "vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "quill/dist/quill.snow.css";
import App from "./App.vue";
import GoogleAuth, { gAuthOptions } from "@/config/googleAuth";
import * as VeeValidate from "vee-validate";
import InfiniteLoading from "vue-infinite-loading";
import VueGoogleCharts from "vue-google-charts";
import Quill from "quill";
import VueCarousel from "@chenfengyuan/vue-carousel";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import VueGtag from "vue-gtag";
import { getProfile, getTaskStatus } from '@/utils/utils'
import { syncAppThemeForSession } from "@/utils/taskDashboardThemes";
import Grid from "vue-js-grid";
import ToggleButton from "vue-js-toggle-button";

Vue.component("vue-carousel", VueCarousel);

Vue.use(VueGoogleCharts);
Vue.use(InfiniteLoading, {
  /* options */
});

Vue.use(VeeValidate, {
  classes: true
});
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

Vue.use(GoogleAuth, gAuthOptions);
Vue.use(Grid);
Vue.use(ToggleButton);

if (process.env.VUE_APP_SENTRY_ENABLED === "TRUE") {
  Sentry.init({
    Vue,
    dsn:
      "https://d5554b78fd384197a64c62bf833b1392@o512275.ingest.sentry.io/5612510",
    integrations: [new Integrations.BrowserTracing()],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  });
}

let Link = Quill.import("formats/link");

class CustomLink extends Link {
  static sanitize(url) {
    let value = super.sanitize(url);
    if (value) {
      for (let i = 0; i < CustomLink.PROTOCOL_WHITELIST.length; i++)
        if (value.startsWith(CustomLink.PROTOCOL_WHITELIST[i])) {
          return value;
        }
      return `http://${value}`;
    }
    return value;
  }
}
Quill.register(CustomLink);

Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA_TACKING_ID
  }
});

syncAppThemeForSession();

const token = localStorage.getItem("user-token"); // user token retrived on authentication

if (token) {
  getProfile() // load the /me data into the store
  getTaskStatus() // load the 5 statuses that are used throughout the app
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
